import React from 'react';
import { Album } from '../../types/album';
import AlbumCover from './AlbumCover';
import { theme } from '../../styles/theme';
import { useWindowSize } from '../../hooks/useWindowSize';

interface AlbumGridProps {
  albums: Album[];
  onAlbumClick: (album: Album) => void;
  searchText?: string;
  getMatchingTracks?: (album: Album) => string[];
}

const AlbumGrid: React.FC<AlbumGridProps> = ({ albums, onAlbumClick, searchText, getMatchingTracks }) => {
  const { isMobile, isTablet } = useWindowSize();
  
  const getGridSettings = () => {
    if (isMobile) {
      return {
        columns: 'repeat(auto-fill, minmax(140px, 1fr))',
        gap: theme.spacing.md,
        padding: theme.spacing.md,
      };
    } else if (isTablet) {
      return {
        columns: 'repeat(auto-fill, minmax(160px, 1fr))',
        gap: theme.spacing.lg,
        padding: theme.spacing.lg,
      };
    } else {
      return {
        columns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: theme.spacing.lg,
        padding: theme.spacing.lg,
      };
    }
  };
  
  const gridSettings = getGridSettings();
  
  const gridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: gridSettings.columns,
    gap: gridSettings.gap,
    padding: gridSettings.padding,
    width: '100%',
    minHeight: 'calc(100vh - 60px)',
  };

  return (
    <div style={gridStyle}>
      {albums.map((album) => (
        <AlbumCover
          key={album.id}
          album={album}
          onClick={() => onAlbumClick(album)}
          matchingTracks={getMatchingTracks ? getMatchingTracks(album) : []}
        />
      ))}
    </div>
  );
};

export default AlbumGrid;